import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * VISIBLE not-found page (audit externe 2026-10-07, F1).
 *
 * Why it exists: the server answers `200 text/html` to ANY URL
 * (`app.get('/*splat')`), so an unknown address used to be swallowed by a
 * `<Route path="*" element={<Navigate to="/home" />} />` — a silent bounce
 * that reads, to the visitor, as "the page exists but is empty". This page
 * says out loud that the address does not exist, and shows the exact path
 * that was attempted (so a stale bookmark or a broken link is diagnosable at
 * a glance).
 *
 * Kept deliberately dumb: no data fetch, no store, no auth check → it can be
 * mounted both INSIDE the protected group (internal catch-all) and OUTSIDE it
 * (unknown public URL), which is exactly what App.tsx does.
 */
export default function NotFoundPage() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="not-found-page" role="status">
      <div className="card not-found-card">
        <p className="not-found-code">404</p>
        <h1 className="not-found-title">{t('notFound.title')}</h1>
        <p className="not-found-body">{t('notFound.body')}</p>
        <code className="not-found-path">{pathname}</code>
        <div className="not-found-actions">
          <button type="button" className="btn btn-primary" onClick={() => nav('/home')}>
            {t('notFound.backHome')}
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => nav(-1)}>
            {t('notFound.back')}
          </button>
        </div>
      </div>
    </div>
  );
}
